// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lawyer_follow-module__container--2EYsS{display:inline-block;margin-right:8px;margin-bottom:1rem}\n", ""]);
// Exports
exports.locals = {
	"container": "lawyer_follow-module__container--2EYsS"
};
module.exports = exports;
